import React, { useEffect, useState } from "react";
import Select from "react-select";
import Spacing from "../../Spacing";
import { useDocumentTitle } from "../../../hooks/customDocumentTitleHook";
import Inputmask from 'inputmask';
import { can_visit, notify } from "../../../helpers";
import { fetchAllSpeciality, onboardPractice } from "../../../services/users";
import { ArrowDownToLine, Eye, EyeOff, Info, Loader, Lock, Plus, X } from "lucide-react";
import { Config } from "../../../Config";

export default function OnboardPractice() {
  const [loading, setLoading] = useState(false);

  const defaultLocationValues = [{
    name: "", 
    website: "", 
    google_map_place_id: "",
    npi_number: null,
    phone: "",
    address1: "",
    city: "",
    state: "",
    zipcode: "",
    specialities: []
  }];
  const [locations, setLocations] = useState(defaultLocationValues);

  const adminInformations = {
    username: "", 
    email: "", 
    first_name: "",
    last_name: "",
    password: "",
    contact: ""
  };
  const [adminInfo, setAdminInfo] = useState(adminInformations);
  const [newPassword, setNewPassword] = useState(false);

  const defaultValues = {
    practice_name: "",
    alt_practice_name: "",
    email: "",
    // contact: "",
    // country: "",
    // city: "",
    // state: "",
    // street: "",
    // zip_code: "",
    available_credit: 2000,
    letter_credit: 500,
    medmo_api_key: "",
    appointment_slug: "",
    logo_link: "",
    appointment_notification_email: "",
    rejection_notification_email: "",
    locations: [],
    admin_info: {}
  }
  const [formData, setFormData] = useState(defaultValues);
  const [ImgStatusCode, setImgStatusCode] = useState(null);
  const [validSlug, setValidSlug] = useState("");
  const [allSpeciality, setAllSpeciality] = useState([]);

  const getAllSpeciality = async () => {
    try {
      const response = await fetchAllSpeciality();
      if (response?.data) {
        const allSpecialities = response?.data?.map((option) => ({
          value: option?.id,
          label: option?.name,
        }))
        setAllSpeciality(allSpecialities);
      };
    } catch (error) {
      // console.log("🚀 ~ getAllSpeciality: ~ error:", error);
    }
  };

  useEffect(() => {
    getAllSpeciality();
  }, []);
  

  useEffect(() => {
    setValidSlug('');
  }, []);

  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "contact") {
      const phoneInputs = document.querySelectorAll('.us_phone');
      Inputmask({
        mask: '(999) 999-9999',
        showMaskOnHover: false,
        showMaskOnFocus: true,
      }).mask(phoneInputs);
    }
    if (name === "appointment_slug") {
      setValidSlug("");
      const lastChar = value.slice(-1);
      let formattedValue = value;
      if (lastChar === ' ') {
        formattedValue = value.slice(0, -1) + '-';
      }
      formattedValue = generateSlug(formattedValue);
      setFormData({
        ...formData,
        [name]: formattedValue,
      });
      return;
    }
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleLocationChange = (index, e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      const phoneInputs = document.querySelectorAll('.us_phone');
      Inputmask({
        mask: '(999) 999-9999',
        showMaskOnHover: false,
        showMaskOnFocus: true,
      }).mask(phoneInputs);
    }

    const newLocations = [...locations];
    newLocations[index][name] = value;
    setLocations(newLocations);
  };

  const addLocation = () => {
    setLocations([...locations, { name: "", website: "", google_map_place_id: "", npi_number: "", phone: "", address1: "", city: "", state: "", zipcode: "", specialities: [] }]);
  };

  const removeLocation = (index) => {
    if (locations.length > 1) {
      const newLocations = locations.filter((_, locIndex) => locIndex !== index);
      setLocations(newLocations);
    }
  };

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      locations: locations
    }));
  }, [locations]);

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      admin_info: adminInfo
    }));
  }, [adminInfo]);

  useEffect(() => {
    checkImageURL(formData.logo_link);
  }, [formData]);

  const handleLogoCheck = (e) => {
    const { name, value } = e.target;
    
    checkImageURL(value);
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const checkImageURL = (img) => {
    if(img !== "") {
      const regex = /\.(jpg|png|gif|jpeg)$/i;
      const match = img?.match(regex);

      if (!match) {
        setImgStatusCode('Error');
        return;
      }

      const LogoImg = new Image();
      LogoImg.onload = () => {
        setImgStatusCode(200);
      };
      LogoImg.onerror = () => {
        setImgStatusCode('Error');
      };
      LogoImg.src = img;
    }
  };

  const handleAdminInfoChange = (e) => {
    const { name, value } = e.target;
    if (name === "contact") {
      const phoneInputs = document.querySelectorAll('.us_phone');
      Inputmask({
        mask: '(999) 999-9999',
        showMaskOnHover: false,
        showMaskOnFocus: true,
      }).mask(phoneInputs);
    }
    setAdminInfo({
      ...adminInfo,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    e.target.disabled = true;
    if(can_visit("administrator") && can_visit("administrator_onboard_practice")) {
      const response = await onboardPractice(formData);
      
      if (response.detail) {
        notify('error', response.detail);
      } else { 
        if(response.data.status === 'success'){
          notify("success", response.data.message);
          setFormData(defaultValues);
          setLocations(defaultLocationValues);
          setAdminInfo(adminInformations);
        } else {
          notify("error", response.data.message);
        }
      }
    }
    
    setLoading(false);
    e.target.disabled = false;
  };

  const handleSpecialityChange = (index, selectedOption) => {
    const selectedValues = selectedOption ? selectedOption.map((option) => option.value) : [];
  
    const newLocations = [...locations];
    newLocations[index].specialities = selectedValues;
    setLocations(newLocations);
  };

  useDocumentTitle("Onboard Practice");

  return (
    <>
      <div className="docpro_page_heading_wrap">
        <h2 className="docpro_page_heading docpro_fs_24">
          Onboard Practice
        </h2>
      </div>

      <div className="pl-2">
        <strong className="docpro_red_color">Important Note: </strong>
        <ul className="pt-1" style={{ listStyle: 'auto', paddingLeft: '30px' }}>
          <li>Before creating a new practice, ensure you have created the organization's practice group in the Keycloak server with a parent location.</li>
          <li>Verify that the Keycloak practice group and location names exactly match those listed here.</li>
          <li>After submitting the form, go to the Keycloak server and set user group permissions.</li>
          <li>Log out and log in again to access the practice.</li>
        </ul>
      </div>

      <div className="docpro_card">
        <form onSubmit={handleSubmit} autoComplete="off" className="relative">
          <div className="flex items-center justify-between">
            <h6 className='docpro_fs_18 docpro_sky_color docpro_mb_0'>Practice Information :</h6>
            <div>
              <a href={`${Config.appUrl}/form_pdfs/Bulk-Onboarding-Practice.xlsx`}
                target="_blank"
                rel="noopener noreferrer"
                download="Onboarding Practice"
                className="docpro_icon_btn last_btn_tip" 
                style={{ padding: '10px 8px', background: '#1578d5', borderRadius: '5px', color: '#ffffff' }}
              >
                <ArrowDownToLine width={20} height={20} />
                <span className="docpro_tip">Download Demo File</span>
              </a>
            </div>
          </div>
          <Spacing lg="25" sm="25" />

          <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_3">
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color">
                Practice Name <span className="docpro_red_color">*</span>
              </label>
              <input type="text" className="docpro_form_field size_lg" name='practice_name' required onChange={handleChange} value={formData.practice_name} />
            </div>
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color">
                ALT Practice Name
              </label>
              <input type="text" className="docpro_form_field size_lg" name='alt_practice_name' onChange={handleChange} defaultValue={formData.alt_practice_name} />
            </div>
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color">
                Email <span className="docpro_red_color">*</span>
              </label>
              <input type="email" className="docpro_form_field size_lg" name='email' required onChange={handleChange} value={formData.email} />
            </div>
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color">
                Medmo API Key
              </label>
              <input type="text" className="docpro_form_field size_lg" name='medmo_api_key' onChange={handleChange} value={formData.medmo_api_key} />
            </div>
            {/* <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color">
                Contact
              </label>
              <input type="text" className="docpro_form_field size_lg us_phone" name='contact'
                onChange={handleChange}
                value={formData.contact}
                maxLength={20} placeholder='(123) 123 1234' />
            </div>
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color">
                Street
              </label>
              <input type="text" className="docpro_form_field size_lg" name='street' onChange={handleChange} value={formData.street} />
            </div>
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color">
                City
              </label>
              <input type="text" className="docpro_form_field size_lg" name='city' onChange={handleChange} value={formData.city} />
            </div>
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color">
                State
              </label>
              <input type="text" className="docpro_form_field size_lg" name='state' onChange={handleChange} value={formData.state} />
            </div>
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color">
                Zip
              </label>
              <input type="text" className="docpro_form_field size_lg" name='zip_code' onChange={handleChange} value={formData.zip_code} />
            </div>
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color">
                Country
              </label>
              <input type="text" className="docpro_form_field size_lg" name='country' onChange={handleChange} value={formData.country} />
            </div> */}
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color">
                Appointment Slug {"  "}
                {validSlug === true ? 
                  <span className="docpro_badge docpro_badge_cyan docpro_square">Available</span>
                : validSlug === false ? 
                  <span className="docpro_badge docpro_badge_red docpro_square">Not Available</span>
                :
                  ""
                }
              </label>
              <div className="docpro_form_field_with_icon_group">
                <div className="docpro_form_field static_text">https://book.doc.pro/</div>
                <input type="text" className="docpro_form_field slug size_lg" name='appointment_slug' placeholder='Slug' onChange={handleChange} value={formData.appointment_slug} style={{ borderRadius: "0 8px 8px 0" }} />
              </div>
            </div>
            <div className="docpro_grid_item">
              <label className="docpro_primary_color">
                <span className='docpro_fw_500 mr-2'>Logo Link</span>
                <button className="docpro_icon_btn overview" style={{ width: 'auto', height: 'auto', borderRadius: '50%' }} >
                  <Info width={14} height={16} className='docpro_accent_color' />
                  <div className="docpro_tip" style={{ textTransform: 'unset' }}>
                    <span>
                      Accept file type: .jpg, .png, .gif <br />
                      Recommended width: 320px
                    </span>
                  </div>
                </button>
              </label>
              <div className="flex items-center" style={{ justifyContent: 'between' }}>
                <div className='w-full mr-2'>
                  <input type="url" className="docpro_form_field size_lg" name='logo_link' value={formData.logo_link} onChange={handleLogoCheck} pattern="https?://.*" placeholder="https://doc.pro/logo.png" />
                </div>
                <div>
                  {ImgStatusCode === null ? (
                    <p className='docpro_fs_14 docpro_mb_0 docpro_red_color' style={{ width: '100px' }}>Provide valid image link</p>
                  ) : ImgStatusCode === 200 ? (
                    <img 
                      src={formData.logo_link} 
                      alt="Logo"
                      style={{ maxHeight: '30px', width: '100%', maxWidth: '180px' }}
                    />
                  ) : (
                    <p className='docpro_fs_14 docpro_mb_0 docpro_red_color' style={{ width: '100px' }}>Provide Valid URL</p>
                  )}
                </div>
              </div>
            </div>
          </div>

          <Spacing lg="30" sm="30" />
          <h6 className='docpro_fs_18 docpro_sky_color'>Location Information :</h6>
          {locations.map((location, index) => (
            <div key={index}>
              
              <div className="flex mb-2 pb-1">
                {index === locations.length - 1 ? (
                  <div className="text-right">
                    <Spacing lg="10" sm="10" />
                    <button 
                      type="button"
                      onClick={addLocation} 
                      className="docpro_icon_btn docpro_fw_600 docpro_primary_color mr-2" 
                      style={{ borderRadius: '50%', height: '30px', width: '30px' }}
                    >
                      <Plus width={20} height={20} />
                      <span className="docpro_tip">Add More Location</span>
                    </button>
                  </div>
                ) : (
                  <div style={{ minWidth: '37px' }}></div>
                )}
                {locations.length > 1 && (
                  <div className="text-right">
                    <Spacing lg="10" sm="10" />
                    <button
                      type="button"
                      onClick={() => removeLocation(index)}
                      className="docpro_icon_btn docpro_red_color docpro_icon_btn_red mr-2"
                      style={{ borderRadius: '50%', height: '30px', width: '30px' }}
                    >
                      <X width={20} height={20} />
                      <span className="docpro_tip">Remove Location</span>
                    </button>
                  </div>
                )}

                {/* <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_3 w-full">
                  <div className="docpro_grid_item">
                    <label className="docpro_fw_500 docpro_primary_color">
                      Practice Location <span className="docpro_red_color">*</span>
                    </label>
                    <input type="text" className="docpro_form_field size_lg" name='name' value={location.name} required onChange={(e) => handleLocationChange(index, e)} />
                  </div>
                  <div className="docpro_grid_item">
                    <label className="docpro_fw_500 docpro_primary_color">
                      Website URL
                    </label>
                    <input type="url" className="docpro_form_field size_lg" name='website' value={location.website} onChange={(e) => handleLocationChange(index, e)} pattern="https?://.*" />
                  </div>
                  <div className="docpro_grid_item">
                    <label className="docpro_fw_500 docpro_primary_color">
                      Google Map Place ID
                    </label>
                    <input type="text" className="docpro_form_field size_lg" name='google_map_place_id' value={location.google_map_place_id} onChange={(e) => handleLocationChange(index, e)} />
                  </div>
                </div> */}

                <div className={`w-full p-2 rounded-md docpro_locations ${index % 2 === 0 && "docpro_bg_light"}`}>
                  <div className={`docpro_grid docpro_grid_gap_20_16 docpro_grid_col_3`}>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Practice Location <span className="docpro_red_color">*</span>
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='name' value={location.name} required onChange={(e) => handleLocationChange(index, e)} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Website URL
                      </label>
                      <input type="url" className="docpro_form_field size_lg" name='website' defaultValue={location?.website} onChange={(e) => handleLocationChange(index, e)} pattern="https?://.*" />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Google Map Place ID
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='google_map_place_id' defaultValue={location?.google_map_place_id} onChange={(e) => handleLocationChange(index, e)} />
                    </div>

                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        NPI Number
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='npi_number' minLength={10} maxLength={10} defaultValue={location?.npi_number} 
                        onChange={(e) => handleLocationChange(index, e)}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        }}
                      />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Phone
                      </label>
                      <input type="text" className="docpro_form_field size_lg us_phone" name='phone' defaultValue={location?.phone} maxLength={20} onChange={(e) => handleLocationChange(index, e)} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Address
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='address1' defaultValue={location?.address1} onChange={(e) => handleLocationChange(index, e)} />
                    </div>

                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        City
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='city' defaultValue={location?.city} onChange={(e) => handleLocationChange(index, e)} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        State
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='state' defaultValue={location?.state} onChange={(e) => handleLocationChange(index, e)} />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Zip Code
                      </label>
                      <input type="text" className="docpro_form_field size_lg" name='zipcode' defaultValue={location?.zipcode} onChange={(e) => handleLocationChange(index, e)} />
                    </div>
                  </div>
                  <Spacing lg="20" sm="20" />
                  <div>
                    <label className="docpro_fw_500 docpro_primary_color">
                      Specialities
                    </label>
                    <Select
                      isMulti
                      name="specialities"
                      options={allSpeciality}
                      placeholder="Search..."
                      isSearchable
                      value={allSpeciality?.filter((option) => 
                        location.specialities?.includes(option.value)
                      ) || []}
                      onChange={(selectedOption) => handleSpecialityChange(index, selectedOption)}
                      className="react-select-container w-full"
                      classNamePrefix="react-select"
                      filterOption={(option, rawInput) => {
                        const words = rawInput.toLowerCase().split(" ");
                        return words.every((word) =>
                          option.label.toLowerCase().includes(word)
                        );
                      }}
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: '40px',
                          borderColor: 'var(--border)',
                          borderRadius: '8px'
                        }),
                        menu: (base) => ({
                          ...base,
                          zIndex: 1050,
                          marginTop: '-2px',
                          borderRadius: '0 0 3px 3px',
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 1050,
                          padding: 0
                        }),
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}

          <Spacing lg="30" sm="30" />
          <h6 className='docpro_fs_18 docpro_sky_color'>Notification Information :</h6>
          <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_3">
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color">
                Appointment Notification Email
              </label>
              <input type="email" className="docpro_form_field size_lg" name='appointment_notification_email' onChange={handleChange} value={formData.appointment_notification_email} />
            </div>
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color">
                Rejection Notification Email
              </label>
              <input type="email" className="docpro_form_field size_lg" name='rejection_notification_email' onChange={handleChange} value={formData.rejection_notification_email} />
            </div>
          </div>

          <Spacing lg="30" sm="30" />
          <h6 className='docpro_fs_18 docpro_sky_color'>Default Credits :</h6>
          <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_3">
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color">
                Message Credit <span className="docpro_red_color">*</span>
              </label>
              <input type="number" className="docpro_form_field size_lg" name='available_credit' required onChange={handleChange} value={formData.available_credit} />
            </div>
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color">
                Letter Credit <span className="docpro_red_color">*</span>
              </label>
              <input type="number" className="docpro_form_field size_lg" name='letter_credit' required onChange={handleChange} value={formData.letter_credit} />
            </div>
          </div>

          <Spacing lg="30" sm="30" />
          <h6 className='docpro_fs_18 docpro_sky_color'>Admin Informations :</h6>
          <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_3">
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color"> Username </label>
              <input type="text" className="docpro_form_field size_lg" name='username' onChange={handleAdminInfoChange} value={adminInfo.username} />
            </div>
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color"> Email </label>
              <input type="email" className="docpro_form_field size_lg" name='email' onChange={handleAdminInfoChange} value={adminInfo.email} />
            </div>
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color"> First Name </label>
              <input type="text" className="docpro_form_field size_lg" name='first_name' onChange={handleAdminInfoChange} value={adminInfo.first_name} />
            </div>
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color"> Last Name </label>
              <input type="text" className="docpro_form_field size_lg" name='last_name' onChange={handleAdminInfoChange} value={adminInfo.last_name} />
            </div>
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color"> Contact </label>
              <input type="text" className="docpro_form_field size_lg us_phone" name='contact' onChange={handleAdminInfoChange} value={adminInfo.contact} />
            </div>
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color"> Password </label>
              <div className="docpro_form_field_with_icon">
                <input
                  name="password"
                  type={newPassword ? "text" : "password"}
                  placeholder="••••••••"
                  className="docpro_form_field size_lg"
                  onChange={handleAdminInfoChange}
                  autoComplete="off"
                  minLength={4}
                />
                <Lock width={18} height={18} className="docpro_form_field_icon" />
                { newPassword ?
                  <Eye onClick={()=>setNewPassword(false)} width={18} height={18} className="docpro_form_field_icon pointer" style={{ color: "#b0b0b0" }} />
                :
                  <EyeOff onClick={()=>setNewPassword(true)} width={18} height={18} className="docpro_form_field_icon pointer" style={{ color: "#b0b0b0" }} />
                }
              </div>
            </div>
          </div>
            {/* <Spacing lg="30" sm="30" />
            <h6 className='docpro_fs_18 docpro_sky_color'>Upload File :</h6>
            <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_3">
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color">
              Upload Patient File
              </label>
              <input
              type="file"
              className="docpro_form_field size_lg"
              name="patient_file"
              accept=".xlsx,.xls,.csv"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                notify("success", `File "${file.name}" selected successfully.`);
                }
              }}
              />
            </div>
            </div>
            
            <Spacing lg="30" sm="30" />
            <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_3">
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color">
              Upload ICD File
              </label>
              <input
              type="file"
              className="docpro_form_field size_lg"
              name="icd_file"
              accept=".xlsx,.xls,.csv"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                notify("success", `File "${file.name}" selected successfully.`);
                }
              }}
              />
            </div>
            </div>

            <Spacing lg="30" sm="30" />
            <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_3">
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color">
              Upload CPT File
              </label>
              <input
              type="file"
              className="docpro_form_field size_lg"
              name="cpt_file"
              accept=".xlsx,.xls,.csv"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                notify("success", `File "${file.name}" selected successfully.`);
                }
              }}
              />
            </div>
            </div> */}

          <Spacing lg="32" sm="32" />
          <div className="docpro_modal_btns">
            <button
              className={`docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg`}
              style={{ pointerEvents: `${loading ? "none" : "initial"}` }}
              type="submit"
            >
              Save
              {loading && (
                <span className="docpro_loading">
                  <Loader width={20} height={20} />
                </span>
              )}
            </button>
          </div>

          {loading && (
            <div className="absolute top-0 left-0 w-full" style={{ height: '100%', zIndex: 3 }}>
              <div className="flex items-center loading" style={{ width: '100%', height: '100%', justifyContent: 'center', background: 'rgb(255 255 255 / 63%)' }}>
                <span className="docpro_loading" style={{ position: 'inherit' }}>
                  <Loader width={46} height={46} style={{ color: 'var(--accent)' }} />
                </span>
              </div>
            </div>
          )}
        </form>

      </div>
    </>
  );
}
